<template>
  <section class="host-text">
    <a href="mailto:hello@oneworldoneface.com">
      <h3 class="text__cont">
        <div class="text__line" v-for="(item, index) in items" :key="index">
          <p>{{ item[0] }}</p>
          <p>{{ item[1] }}</p>
          <p>{{ item[2] }}</p> 
        </div>
      </h3>
    </a>
  </section>
</template>

<script>
export default {
  name: 'host',

  data() {
    return {
      items: [
        ['HOST', 'IN YOUR', 'CITY'],
        ['IN YOUR', 'CITY', 'HOST'],
        ['CITY', 'HOST', 'IN YOUR'],
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/colors';
@import '../application';

:global {
  @keyframes moveWords {
    0% {
      transform: translateY(0%);
    }
    50% {
      transform: translateY(-101%);
    }
    100% {
      transform: translateY(0%);
    }
  }
}

.host-text {
  position: relative;
  padding: 80px 0;

  @include mq(sm) {
    padding: 180px 0;
  }

  a {
    display: block;
    width: 500px;
    margin: 0 auto;

    color: transparent;
    -webkit-text-stroke: 2px #1217ff;

    transform: scale(0.75) translateX(-22%);

    cursor: pointer;

    @include mq(sm) {
      transform: none;
    }
  }
}

.text__cont {
  margin: 0;
  padding: 0;

  font-size: 5.375rem;
  text-transform: uppercase;
  font-weight: bold;
  text-align: center;

  .text__line {
    height: 4.375rem;

    white-space: nowrap;
    line-height: 0.9;

    overflow: hidden;

    &:first-child {
      & + .text__line {
        margin-left: 81px;

        & + .text__line {
          margin-left: 161px;
        }
      }
    }

    &:nth-child(odd) {
      transform: skew(60deg,-20deg) scaleY(.66667);
    }

    &:nth-child(even) {
      transform: skew(0deg,-20deg) scaleY(1.33333);
    }

    p {
      height: 70px;
      margin: 0;

      font-size: 1em;
      line-height: .9;
      white-space: nowrap;
      color: transparent;
      -webkit-text-stroke: 2px $color-blue;

      animation: moveWords 6s infinite ease;

      overflow: hidden;

      @at-root .pointerevents:not(.touchevents) &:hover,
      .no-pointerevents.no-touchevents &:hover {
        color: $color-blue;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/InfoHost.vue